<template>
  <div class="mt-8">
    <px-view-module-header module-name="Marketplace" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Ofertas"/>
        <px-ofertas-header class="mt-5"
                           @refresh="onClickRefresh"
                           @change="onChangeFilter"/>
        <px-ofertas-list :ofertas="ofertas"
                         :loading="loading"
                         :on-change-options="onChangeOptions"
                         :options-list="optionsList"/>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import OfertaService from './oferta-service';
import OfertasHeader from './OfertasHeader.vue';
import OfertasList from './OfertasList.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      empresa: null,
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Ofertas' },
      ],
      ofertas: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'titulo',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemMarketplaceOfertas', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getOfertas();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getOfertas();
    },
    onClickRefresh() {
      this.getOfertas();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getOfertas() {
      this.loading = true;
      const {
        limit,
        offset,
      } = this.listOptions;
      return OfertaService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.ofertas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxOfertasHeader: OfertasHeader,
    pxOfertasList: OfertasList,
  },
};
</script>
